import React from "react";
import { LinkedIn } from "assets";
import style from "./innernavbar.module.scss";
import { Link, useNavigate } from "react-router-dom";

const InnerNavbar = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className={style.navbar}>
        <div className={style.links}>
          <div
            onClick={() => {
              navigate("/info", { state: { view: 0 } });
            }}
          >
            <p>Innovation</p>
          </div>
          <div
            onClick={() => {
              navigate("/info", { state: { view: 1 } });
            }}
          >
            <p>Ethics</p>
          </div>
          <div
            onClick={() => {
              navigate("/info", { state: { view: 5 } });
            }}
          >
            <p>Drive</p>
          </div>
          <div
            onClick={() => {
              navigate("/info", { state: { view: 2 } });
            }}
          >
            <p>Passion</p>
          </div>
          <div
            onClick={() => {
              navigate("/info", { state: { view: 3 } });
            }}
          >
            <p>Intelligence</p>
          </div>
          <div
            onClick={() => {
              navigate("/info", { state: { view: 4 } });
            }}
          >
            <p>Grit</p>
          </div>
        </div>
        <div className={style.social}>
          <button>
            <img src={LinkedIn} alt="" />
          </button>
        </div>
      </div>
    </>
  );
};

const InnerNavbarPage = ({ setView }) => {
  return (
    <>
      <div className={style.navbarPage}>
        <div className={style.links}>
          <div
            onClick={() => {
              setView(0);
            }}
          >
            <p>Innovation</p>
          </div>
          <div
            onClick={() => {
              setView(1);
            }}
          >
            <p>Ethics</p>
          </div>
          <div
            onClick={() => {
              setView(5);
            }}
          >
            <p>Drive</p>
          </div>
          <div
            onClick={() => {
              setView(2);
            }}
          >
            <p>Passion</p>
          </div>
          <div
            onClick={() => {
              setView(3);
            }}
          >
            <p>Intelligence</p>
          </div>
          <div
            onClick={() => {
              setView(4);
            }}
          >
            <p>Grit</p>
          </div>
        </div>
        <div className={style.social}>
          <button>
            <img src={LinkedIn} alt="" />
          </button>
        </div>
      </div>
    </>
  );
};

export { InnerNavbar, InnerNavbarPage };
